/**
 * Module Access Matrix — frontend helpers.
 * Backend source of truth is /api/auth/me → user.module_permissions.
 *
 * Modules covered (keys must stay in sync with backend MODULE_DEFS):
 *   dashboard | spares | reports | av | pv | masters | security | loc | admin
 *
 * Actions: view | add | edit | delete
 * Admin role always has all four on all modules (regardless of DB).
 */

export const MODULE_KEYS = [
  "dashboard", "spares", "reports", "av", "pv", "masters", "security", "loc", "admin",
];

export const MODULE_LABELS = {
  dashboard: "Spare Dashboard",
  spares:    "Spares",
  reports:   "Reports",
  av:        "Accidental Vehicles",
  pv:        "Pending Vehicles",
  masters:   "Masters",
  security:  "Security",
  loc:       "LOC Tracker",
  admin:     "Admin",
};

export const MODULE_ACTIONS = ["view", "add", "edit", "delete"];

/** Map a route pathname → the module key that owns it (best-effort). */
export const routeToModule = (pathname = "") => {
  if (pathname === "/" || pathname === "") return "dashboard";
  if (pathname.startsWith("/admin")) return "admin";
  if (pathname.startsWith("/av/")) return "av";
  if (pathname.startsWith("/pv/")) return "pv";
  if (pathname.startsWith("/loc")) return "loc";
  if (pathname.startsWith("/masters/")) return "masters";
  if (pathname.startsWith("/security/")) return "security";
  // Spares group
  if (
    pathname.startsWith("/create") ||
    pathname.startsWith("/workbench") ||
    pathname.startsWith("/packing-slip/new") ||
    pathname.startsWith("/stock-planning")
  ) return "spares";
  // Reports group
  if (
    pathname.startsWith("/orders") ||
    pathname.startsWith("/reports") ||
    pathname.startsWith("/packing-slips")
  ) return "reports";
  return null;
};

/**
 * Check whether `user` can perform `action` on `moduleKey`.
 * Admin role bypasses everything and returns true.
 */
export const hasPerm = (user, moduleKey, action = "view") => {
  if (!user) return false;
  if (user.role === "admin") return true;
  const perms = user.module_permissions || {};
  const mod = perms[moduleKey];
  if (!mod) return false;
  return !!mod[action];
};
